export { default } from '@triptyk/ember-utils/services/store-document';
